import { graphql, useStaticQuery } from 'gatsby'

const contentfulLocalizedBannerMicroCopy = () => {
  return useStaticQuery(graphql`
    {
      contentfulMicrocopySet(key: { eq: "BrowserLanguage" }) {
        key
        node_locale
        values {
          id
          key
          value
        }
      }
    }
  `)
}

export default { contentfulLocalizedBannerMicroCopy }
